import classNames from 'classnames';
import React from 'react';
import { ProIconType } from '../../constants/types';
import { ProIntent, ProSize } from '../../utils/enums';
import { Components } from '../../utils/types';
import { ProIcon } from '../Icons/Icon';

type Props = {
    state?: Components.Schemas.DeltaStateType;
    percent?: number;
    icon: ProIconType;
};

export const ProStatus = ({ percent, state, icon }: Props) => {
    return (
        <div className={classNames(`ProStatus__tag`, `ProStatus--tag__${state}`)}>
            <ProIcon icon={icon} intent={ProIntent.Light} size={ProSize.Small} />
            {Number.isInteger(percent) ? percent : '-'}
        </div>
    );
};
